import DishyearsPatches from './DishyearsPatches';
import DishyearsData from './DishyearsData';

function App() {
  // scrolls smoothly to a certain section
  const dishClick = () => {
    document.querySelector("#dish").scrollIntoView ({ 
      behavior: "smooth"
    });
  }

  return (
    <div>
      <main className="main__bg">
        <div className="container container--main top-bottom__main">
          <div>
            <DishyearsPatches /> 
          </div>

          <div className="flex flex--main">
            <svg className="main__col main__col--all" viewBox="0 0 157.09 73.31">
              <polygon points="153.55 36.66 78.55 71.66 3.55 36.66 78.55 1.66 153.55 36.66" fill="#02B54E" stroke="#000" strokeWidth="3" vectorEffect="non-scaling-stroke"/>
              <text title="ALL" role="paragraph" transform="translate(48.23 48.53)">ALL</text>
            </svg>
            
            <svg className="main__col main__col--title" viewBox="0 0 504 144.76">
              <path d="M470.9,72.37a31.82,31.82,0,0,0,31.6,31.83v39.06H1.5V104.19H2A31.83,31.83,0,0,0,2,40.55H1.5V1.5h501V40.55A31.82,31.82,0,0,0,470.9,72.37Z" fill="#f9ea20" stroke="#000" strokeWidth="3" vectorEffect="non-scaling-stroke"/>
              <text title="dishyears" role="heading" transform="translate(94.32 100.46)">dishyears</text>
            </svg>              
            
            <p className="main__col main__col--description">and I still love reliving the story of each bite.</p>
            <button className="main__col main__col--button" onClick={dishClick}>Let's read!</button>
          </div>
        </div>
      </main>

      <section id="dish">
        <DishyearsData /> 
      </section>

      <footer className="container top-bottom__footer flex--footer">
        <div className="width--hundred">
          <h3 className="footer__title">Typography</h3>
          <ul>
            <li><a href="https://velvetyne.fr/fonts/savate/" rel="noopener noreferrer" target="_blank" className="link">Savate↗</a> by Wech (Velvetyne Type Foundry)</li>
            <li><a href="https://fonts.google.com/specimen/Montserrat" rel="noopener noreferrer" target="_blank" className="link">Montserrat↗</a> by Julieta Ulanovsky, Sol Matas, Juan Pablo del Peral, & Jacques Le Bailly (Google Fonts)</li>
          </ul>
        </div>
        <div className="footer__code width--hundred">
          <h3 className="footer__title">Code & Design</h3>
          <a href="https://www.abbydb.com/" rel="noopener noreferrer" target="_blank" className="link">Abby↗</a>
          {/* <p>Abby</p> */}
        </div>
      </footer>            
    </div>
  );
}

export default App;